<template>
    <div>
        <v-dialog v-model="openDialog" persistent>
            <v-card>
                <v-card-title>
                {{ formTitle }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                <v-container>
                <ValidationObserver ref="observer">
                    <form>
                        <v-row>
                            <v-col cols="6">
                              <ValidationProvider v-slot="{ errors }" name="Tipo" rules="required">
                                <v-select label="Tipo" v-model="frmItem.typeRule" :no-data-text="noDataAvailable"
                                          :items="getTypeRules()" item-text="value" item-value="id" v-on:change="clearRuleConfigs"
                                          :error-messages="errors" required>
                                </v-select>
                              </ValidationProvider>
                            </v-col>

                          <v-col cols="6">
                            <header class="mb-3">Path</header>
                            <label class="mt-5">{{path}}</label>
                          </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="6" sm="4" md="2" v-if="isUser()">
                            <header>Permissão</header>
                            <v-switch v-model="frmItem.permission"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2" v-if="isNotGlobal() && isRoleCreationBackoffice()">
                            <header>Upload</header>
                            <v-switch v-model="frmItem.upload"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2" v-if="isNotGlobal() && isRoleCreationBackoffice()">
                            <header>Criar</header>
                            <v-switch v-model="frmItem.add"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2" v-if="isNotGlobal() && isRoleCreationBackoffice()">
                            <header>Renomear</header>
                            <v-switch v-model="frmItem.rename"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2" v-if="isNotGlobal() && isRoleCreationBackoffice()">
                            <header>Excluir</header>
                            <v-switch v-model="frmItem.delete"></v-switch>
                        </v-col>
                        <v-col cols="6" sm="4" md="2">
                            <header>Ativa</header>
                            <v-switch v-model="frmItem.active"></v-switch>
                        </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" v-if="isNotGlobal()">
                            <ValidationProvider v-slot="{ errors }" name="Path" rules="max:255">
                              <v-text-field label="Valor" v-model="frmItem.accessJson"
                                            prepend-icon="mdi-account-check" :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                            <span v-if="frmItem.typeRule === 'SUBCONTRACT' && !isValidSubcontractFormat" style="color: red;">
                              Formato inválido para o valor do Subcontrato (Apólice_Contrato-Número_Sub).
                            </span>
                          </v-col>
                        </v-row>
                    </form>
                </ValidationObserver>
                </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="accessPermissionDialogButtons" text @click="close">Cancelar</v-btn>
                    <v-btn color="accessPermissionDialogButtons" text @click="save">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { required, max } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} não pode ser vazio',
});

extend('max', {
  ...max,
  message: '{_field_} não pode ter mais do que {length} characteres',
});

export default {
  name: 'DialogItem',
  components: {
    ValidationProvider,
    ValidationObserver,
    // tableRuleConfigs,
  },
  props: {
    open: Boolean,
    ruleGroups: Array,
    editedItem: {},
    editing: Boolean,
    path: String,
    userRoleCreation: String,
    userRoleApply: String,
    allowedTypeRules: Array,
  },

  data: () => ({
    isValidSubcontractFormat: true,
    dialogSearch: false,
    searchDialogSearch: '',
    selectedDialogSearch: [],
    headersSearch: [
      { text: 'Descrição', value: 'description' },
    ],
    defaultItem: {
      description: '',
      path: '',
      permission: true,
    },
    frmItem: {},
    openDialog: false,
    allProfiles: [],
    searchedUsers: [],
    searchedUserGroups: [],
    loadingSearchData: false,
    searchPagination: {
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
    },
    allTypeRules: [
      { id: 'GLOBAL', value: 'Global' },
      { id: 'CONTRACT', value: 'Contrato' },
      { id: 'SUBCONTRACT', value: 'Subcontrato' },
      { id: 'PROFILE', value: 'Perfil' },
      { id: 'USER', value: 'Usuário' },
    ],
    noDataAvailable: 'Nenhum dado encontrado',
  }),

  computed: {
    formTitle() {
      return !this.editing ? 'Nova regra' : 'Editar regra';
    },
  },

  watch: {
    open() {
      this.openDialog = this.open;
    },
    editedItem() {
      this.frmItem = { ...this.editedItem };
    },
    dialogSearch() {
      if (this.dialogSearch) {
        this.inicializeDialogSearch();
      }
    },
  },

  methods: {
    clearRuleConfigs() {
      this.frmItem.ruleConfigs = [];
    },
    getTypeRules() {
      if (this.allowedTypeRules) {
        return this.allTypeRules.filter((item) => this.allowedTypeRules.includes(item.id));
      } return this.allTypeRules;
    },
    isNotGlobal() {
      return this.frmItem.typeRule && this.frmItem.typeRule !== 'GLOBAL';
    },
    isUser() {
      return this.frmItem.typeRule && this.frmItem.typeRule === 'USER';
    },
    isRoleCreationBackoffice() {
      return this.userRoleCreation && this.userRoleCreation === 'BACKOFFICE';
    },
    close() {
      this.$refs.observer.reset();
      this.$emit('closeDialogItem');
    },

    save() {
      if (this.frmItem.typeRule === 'SUBCONTRACT') {
        const { accessJson } = this.frmItem;
        if (accessJson) {
          const accessJsonParts = accessJson.split(',');
          if (accessJsonParts && accessJsonParts.length) {
            const includesFormat = accessJsonParts.every((item) => item && item.includes('-'));
            if (includesFormat) {
              this.isValidSubcontractFormat = true;
              this.emitSave();
            } else {
              this.isValidSubcontractFormat = false;
            }
          }
        }
      } else {
        this.emitSave();
      }
    },

    emitSave() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.frmItem.path = this.path;
          this.frmItem.userRoleApply = this.userRoleApply;
          this.frmItem.userRoleCreation = this.userRoleCreation;
          this.$emit('saveDialogItem', this.frmItem);
          this.$refs.observer.reset();
        }
      });
    },

    btnCancelDialogSearch() {
      this.selectedDialogSearch = [];
      this.dialogSearch = false;
    },

    btnSelectDialogSearch() {
      if (!this.frmItem.ruleConfigs) {
        this.frmItem.ruleConfigs = [];
      }

      this.dialogSearch = false;
      this.selectedDialogSearch = [];
    },

    deleteTableRuleConfig(item) {
      const deleteIndex = this.frmItem.ruleConfigs.findIndex((r) => r.idEntityTypeRule === item.idEntityTypeRule);
      this.frmItem.ruleConfigs.splice(deleteIndex, 1);
    },

    inicializeDialogSearch() {
      this.searchDialogSearch = '';
      this.searchPagination = {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
      };

      if (this.frmItem.typeRule === 'PROFILE') {
        this.allProfiles = [];
        this.loadingSearchData = true;
      } else if (this.frmItem.typeRule === 'USER') {
        this.searchedUsers = [];
        this.loadUsersPageSearchDialog();
      }
    },

    searchDialogUpdatePage() {
      this.loadUsersPageSearchDialog();
    },

    loadUsersPageSearchDialog(newPage) {
      if (newPage) {
        this.searchPagination.page = newPage;
      }

      this.loadingSearchData = true;

      const paramsPage = new URLSearchParams();
      paramsPage.append('page', this.searchPagination.page - 1);
      paramsPage.append('size', this.searchPagination.rowsPerPage);
      paramsPage.append('sort', 'login');
    },

    searchDialogSearchChange() {
      if (this.frmItem.typeRule === 'USER') {
        const actualValueTerm = this.searchDialogSearch;
        const delay = (ms) => new Promise((res) => setTimeout(res, ms));
        const loadBeforeSeconds = async (term, self) => {
          await delay(4000);
          if (term === self.searchDialogSearch) {
            self.loadUsersPageSearchDialog(1);
          }
        };
        loadBeforeSeconds(actualValueTerm, this);
      }
    },

  },
};
</script>
